import React from 'react'
import style from './footer.module.scss'
import LogoSingle from '../../../resources/assets/images/ibanfirst-logo-single.svg'
import { VegaSelectLang } from '../../vega/select/Select'

/**
 * The footer component of the payment tracker
 */
const Footer = () => {
	const year = new Date().getFullYear()
	return (
		<div className={style.footer}>
			<div className={style.container}>
				<div className={style.left}>
					<img src={LogoSingle} width={130} alt={'iBanFirst'} />
				</div>
				<div className={style.middle}>
					<span>{'© Copyright iBanFirst.com ' + year}</span>
					<a className={style.link} href={'http://ibanfirst.com/privacy-policy'}>
						{'Privacy policy'}
					</a>
					<a className={style.link} href={'http://ibanfirst.com/legal'}>
						{'Legal'}
					</a>
					<a className={style.link} href={'https://ibanfirst.com/terms/'}>
						{'Terms of use'}
					</a>
				</div>
				<div className={style.right}>
					<VegaSelectLang className={style.languages} />
				</div>
			</div>
		</div>
	)
}

Footer.propTypes = {}

export { Footer }
